import React from "react";
import {
	Link
} from "react-router-dom";
import config from './../config.js';
import Footer from './../site/common/footer';
import './../../style/home.css';
import './../../style/signin.css';
export default class Register extends React.Component {
	constructor(props) {
		super(props);
		let user = {};
		if (typeof localStorage.from === 'undefined' || localStorage.from === '') {
			props.history.replace('/workstation/register');
			return;
		}
	}

	render() {
		return (
			<div className="text-center mt-3 pt-3">
				<h1>恭喜，注册成功。</h1>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/workstation/register_success.js